module.exports = __webpack_public_path__ + "img/new_file.8cdcdc64.png";